import React from 'react';
import { Navigate } from 'react-router-dom';
import useRoleAuthentication from '../../Authentication/hooks/useRoleAuthentication';

/**
 * Protected Route Component
 * Handles route-level authorization using semantic permissions
 */
function ProtectedRoute({ children, requiresAdminAccess = false }) {
  const auth = useRoleAuthentication();

  // Check if user is logged in
  if (!auth.isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  // Check admin access requirement
  if (requiresAdminAccess && !auth.canAccessAdminDashboard) {
    // Redirect to main dashboard instead of unauthorized page
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedRoute;